import { APP_NAME, START_URL, WHITE_LABEL_ID } from '../BuildConstants';
import { Standalone } from './Utilities';

export const addMetaData = () => {
  const webAppCapable = document.createElement('meta');
  const webAppTitle = document.createElement('meta');
  const webAppStartUrl = document.createElement('meta');

  webAppCapable.setAttribute('name', 'apple-mobile-web-app-capable');
  webAppCapable.setAttribute('content', 'yes');

  webAppTitle.setAttribute('name', 'apple-mobile-web-app-title');
  webAppTitle.setAttribute('content', APP_NAME);

  webAppStartUrl.setAttribute('name', 'msapplication-starturl');
  webAppStartUrl.setAttribute('content', START_URL || window.location.href);

  // Parse the icons.

  const iconSizes = [128, 144, 162, 192, 256, 512];
  const icons = iconSizes.map(iconSize => {
    return {
      src: `https://flipdish.blob.core.windows.net/white-label-assets/whitelabelconfigs/${WHITE_LABEL_ID}/appicon.png?w=${iconSize}&h=${iconSize}`,
      sizes: `${iconSize}x${iconSize}`
    };
  });

  for (let iconIdx = 0; iconIdx < icons.length; iconIdx++) {
    const iconElement = document.createElement('link');
    const icon = icons[iconIdx];

    iconElement.setAttribute('rel', 'apple-touch-icon');
    iconElement.setAttribute('href', icon.src);
    iconElement.setAttribute('sizes', icon.sizes);

    document.head.appendChild(iconElement);
  }
  document.head.appendChild(webAppCapable);
  document.head.appendChild(webAppTitle);
  document.head.appendChild(webAppStartUrl);
};

export const simulateStartUrl = () => {
  const startUrlEl = document.querySelector(
    'meta[name=msapplication-starturl]'
  );
  if (!!startUrlEl === true && Standalone && startUrlEl) {
    window.location.replace((startUrlEl as any).content);
  }
};
